import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { computed, ref, watch } from 'vue';
import { Menu } from 'ant-design-vue';
import XMenuItem from './menuItem.vue';
export default {
  name: 'XMenu',
  components: {
    AMenu: Menu,
    XMenuItem
  },
  props: {
    theme: {
      type: String,
      default: 'light'
    },
    openKeys: {
      type: Array,
      default: () => []
    },
    items: {
      type: Array,
      default: () => []
    }
  },
  emits: ['change-open-keys', 'item-click'],
  setup(props, context) {
    const openKeyRef = ref([]);
    const selectKeysRef = ref([]);
    const menuItems = computed(() => {
      return props.items.map((item, index) => {
        const {
          title,
          name = '',
          icon = '',
          action,
          children
        } = item;
        return {
          title,
          name,
          icon,
          action,
          children
        };
      });
    });
    watch(() => props.openKeys, val => {
      openKeyRef.value = val;
      context.emit('change-open-keys', val);
    }, {
      immediate: true
    });
    const handleItemClick = item => {
      context.emit('item-click', item);
    };
    return {
      menuItems,
      openKeyRef,
      selectKeysRef,
      handleItemClick
    };
  }
};